var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "info-outline_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#info-outline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11.166c.141 0 .26-.047.356-.143a.484.484 0 00.143-.357V7.833a.484.484 0 00-.143-.356.484.484 0 00-.357-.144.483.483 0 00-.356.144.484.484 0 00-.144.356v2.833c0 .142.048.26.144.357a.484.484 0 00.357.143zm0-4.974c.152 0 .28-.051.383-.155a.521.521 0 00.155-.383.521.521 0 00-.155-.384.521.521 0 00-.384-.155.521.521 0 00-.383.155.521.521 0 00-.155.384c0 .152.051.28.155.383a.521.521 0 00.383.155zm0 8.141a6.17 6.17 0 01-2.47-.498A6.396 6.396 0 013.52 12.48a6.397 6.397 0 01-1.354-2.01A6.164 6.164 0 011.666 8c0-.876.166-1.7.499-2.47A6.397 6.397 0 013.518 3.52a6.396 6.396 0 012.01-1.355 6.164 6.164 0 012.47-.498c.876 0 1.7.166 2.47.498.771.333 1.442.784 2.012 1.354.57.57 1.021 1.24 1.354 2.01.332.77.499 1.594.499 2.47 0 .876-.167 1.7-.499 2.47a6.396 6.396 0 01-1.354 2.011 6.395 6.395 0 01-2.01 1.354 6.163 6.163 0 01-2.47.5zm0-1c1.488 0 2.75-.517 3.783-1.55S13.333 9.49 13.333 8c0-1.489-.517-2.75-1.55-3.784-1.034-1.033-2.295-1.55-3.784-1.55-1.489 0-2.75.517-3.783 1.55C3.183 5.25 2.666 6.511 2.666 8c0 1.489.517 2.75 1.55 3.783 1.033 1.034 2.294 1.55 3.783 1.55z",
    fill: "#666"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/info-outline.bfd25a2f.svg";
export { SvgInfoOutline as ReactComponent };